import React from 'react';
import { Link } from 'react-router-dom';

// --- PASO 3: Asegúrate de tener una imagen en esta ruta ---
// Se recomienda una imagen vertical o cuadrada para mejor visualización en móvil.
import aboutImage from '../../assets/images/perfil.png'; 

const AboutPage = () => {
  // --- PASO 5: Actualiza tu email de contacto aquí ---
  const contactEmail = "gus@gusaguiar.com";

  return (
    <div className="bg-gray-900 text-white min-h-screen font-sans selection:bg-yellow-500 selection:text-black">
      <main className="max-w-4xl mx-auto px-6 py-20 sm:py-24">

        {/* --- SECCIÓN DE INTRODUCCIÓN --- */}
        <section className="text-center mb-16">
          <img 
            src={aboutImage} 
            alt="Gustavo Aguiar" 
            className="w-48 h-48 rounded-full mx-auto mb-6 object-cover shadow-2xl shadow-yellow-500/10 border-4 border-gray-800"
          />
          <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-500 mb-4">
            De la Lógica del Código a la Ingeniería de la Conciencia
          </h1>
          <p className="text-lg text-gray-400 font-light max-w-3xl mx-auto">
            Mi nombre es Gustavo Aguiar. Mi misión es ser el puente entre el mundo analítico y el universo espiritual, para guiarte a ser el arquitecto de tu propia realidad.
          </p>
        </section>

        {/* --- CUERPO DE LA HISTORIA --- */}
        <div className="prose prose-invert prose-lg max-w-none text-gray-300 space-y-6">
          <p>
            Durante más de una década, mi mundo giraba en torno a la lógica, los sistemas y los algoritmos. Como <strong>ingeniero y programador</strong>, mi trabajo consistía en construir realidades digitales. Alcancé el "éxito" que se esperaba de mí: una carrera estable, una vida estructurada. Pero, ¿alguna vez has sentido que tienes todas las piezas correctas del rompecabezas, pero la imagen final se siente <strong>vacía</strong>? Esa era mi realidad.
          </p>
          <p>
            En 2017, tras un profundo despertar espiritual, mi estructura se desmoronó. Dejé mi carrera y cambié los servidores por una mochila y un pasaje de ida. Me formé como instructor de Yoga y empecé a explorar la meditación, la metafísica y el poder de la respiración.
          </p>
          <p>
            Sin embargo, la verdadera prueba llegó en 2020. La pandemia me encontró solo y caí en una profunda crisis de ansiedad que me llevó a la medicación y a un estado depresivo. En agosto de 2022, toqué fondo. Y desde ese lugar, tomé la decisión más importante de mi vida: <strong>dejar de ser una víctima para convertirme en el protagonista de mi sanación</strong>.
          </p>
          <p>
            Usando la gratitud, la meditación y el breathwork, empecé a reprogramar mi propia mente. Entendí que las mismas habilidades de análisis y sistematización que usaba en la ingeniería podían aplicarse para entender las <strong>leyes universales y los principios de la manifestación</strong>. Aprendí a "debuggear" mis creencias limitantes.
          </p>
        </div>

        {/* --- DIVISOR --- */}
        <div className="my-16 border-t border-yellow-500/20"></div>

        {/* --- SECCIÓN DE SERVICIOS / CTA --- */}
        <section>
          <h2 className="text-3xl font-bold text-center text-white mb-10">
            Cómo Puedo Ayudarte
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            
            {/* Card 1: Transformación Personal */}
            <div className="bg-gray-800/50 border border-yellow-500/30 rounded-2xl p-8 flex flex-col items-center text-center shadow-lg hover:shadow-yellow-500/10 hover:border-yellow-500/50 transition-all duration-300">
              <h3 className="text-2xl font-bold text-yellow-400 mb-3">Transformación Personal</h3>
              <p className="text-gray-300 mb-6 flex-grow">
                He volcado mi viaje en un protocolo paso a paso para guiar a profesionales lógicos a conectar con su propósito, sanar el vacío interior y manifestar la vida que realmente desean.
              </p>
              <Link 
                to="/cursos/manifiesta" 
                className="w-full bg-yellow-500 text-black font-bold py-3 px-8 rounded-lg hover:bg-yellow-400 transition-transform transform hover:scale-105"
              >
                Explorar el Programa "Manifiesta"
              </Link>
            </div>

            {/* Card 2: Desarrollo Consciente */}
            <div className="bg-gray-800/50 border border-cyan-500/30 rounded-2xl p-8 flex flex-col items-center text-center shadow-lg hover:shadow-cyan-500/10 hover:border-cyan-500/50 transition-all duration-300">
              <h3 className="text-2xl font-bold text-cyan-400 mb-3">Tecnología con Alma</h3>
              <p className="text-gray-300 mb-6 flex-grow">
                Mi amor por crear código evolucionó. Si tienes un proyecto, app o plataforma que busca generar un impacto positivo y elevar la conciencia, podemos construirlo juntos.
              </p>
              <a 
                href={`mailto:${contactEmail}`}
                className="w-full bg-cyan-500 text-black font-bold py-3 px-8 rounded-lg hover:bg-cyan-400 transition-transform transform hover:scale-105"
              >
                Hablemos de tu Proyecto
              </a>
            </div>

          </div>
        </section>

      </main>
      <footer className="text-center py-8 mt-4 border-t border-gray-800">
        <p className="text-sm text-gray-500">© {new Date().getFullYear()} Gustavo Aguiar | En misión de elevar y transformar.</p>
      </footer>
    </div>
  );
};

export default AboutPage;